import React, { ChangeEvent } from 'react';

export const PhotoField = ({
  id,
  label,
  image,
  centered,
  onSelect,
  onRemove
}: {
  id: string;
  label: string;
  image: string;
  centered?: boolean;
  onSelect: (event: ChangeEvent<HTMLInputElement>) => void;
  onRemove: () => void;
}) => (
  <div className={`form-group photo-group ${centered ? 'photo-centered' : ''}`}>
    <label htmlFor={id}>{label}</label>
    <div className="photo-upload-container">
      {image ? (
        <div className="photo-preview">
          <img src={image} alt={label} className="participant-photo" />
          <button type="button" className="btn-remove-photo" onClick={onRemove}>
            ×
          </button>
        </div>
      ) : (
        <div className="photo-upload">
          <input id={id} name={id} type="file" accept="image/*,.heic,.heif" required onChange={onSelect} />
          <label htmlFor={id} className="upload-label">
            <span className="upload-icon">▧</span>
            <span>Selecionar Foto</span>
            <small>JPG, PNG, WEBP ou HEIC</small>
          </label>
        </div>
      )}
    </div>
  </div>
);
